/** Výchozí copy pro veřejnou pozvánku (když pár text nevyplní). */

export const CATERING_SECTION_INTRO_DEFAULT =
  'Těšíme se, že s námi oslavíte celý den — o občerstvení bude postaráno průběžně po celou dobu.';

export const CATERING_MAIN_TITLE = 'Hlavní chod';
export const CATERING_MAIN_BODY_DEFAULT = 'Servírované jídlo během večera.';

export const CATERING_WARM_TITLE = 'Teplý raut';
export const CATERING_WARM_BODY_DEFAULT = `- výběr masových pokrmů (kuřecí, vepřové, hovězí i ryby)
- tradiční i vydatná jídla
- teplá jídla během dne i večera (např. guláš)

a další podle aktuální nabídky`;

export const CATERING_COLD_TITLE = 'Studený raut';
export const CATERING_COLD_BODY_DEFAULT = `- zeleninové a masové mísy
- lehké občerstvení k zakousnutí
- tortilly a drobné dobroty

k dispozici průběžně během dne`;

export const CATERING_SWEET_TITLE = 'Sweet bar';
export const CATERING_SWEET_BODY_DEFAULT = `- výběr dezertů a sladkostí
- domácí i moderní dobroty
- sladké ke kávě i jen tak

pro milovníky sladkého po celý den`;

export const CATERING_DRINKS_TITLE = 'Nápoje';
export const CATERING_DRINKS_BODY_DEFAULT = `- pivo a nealkoholické nápoje (včetně Kofoly)
- výběr alkoholických nápojů
- míchané drinky (gin s tonikem, rum s colou, Aperol a další)

o žízeň se bát nemusíte`;

export const MUSIC_INTRO_DEFAULT =
  'Večer doplníme hudbu tak, aby si každý užil tanec i posezení. Níže najdete, jak u nás bude hudba probíhat.';

export const MUSIC_PLAYLIST_CTA_DEFAULT =
  'Připravili jsme společný playlist na Spotify. Budeme rádi, když do něj přidáte pár skladeb, u kterých byste si rádi zatančili nebo které k naší oslavě patří — ať je večer trochu i váš.';

export const ENTERTAINMENT_INTRO_DEFAULT =
  'Kromě tance a hudby pro vás chystáme ještě následující body programu.';

export const ACCOMMODATION_INFO_DEFAULT = `Pro mimozlínské je ubytování zajištěno v Baltaci Hotel U Náhonu. Check-in je od 14:00. Od cca 14:30 vám bude zajištěn odvoz na místo konání svatby.`;

export const ACCOMMODATION_MAPS_URL_DEFAULT =
  'https://www.google.com/maps/search/?api=1&query=Baltaci+Hotel+U+N%C3%A1honu+Zl%C3%ADn';

export function musicSourceDescription(liveDj: boolean, fromSpeakers: boolean): string | null {
  if (liveDj && fromSpeakers) {
    return 'Část večera obstará živý DJ, jindy zazní vybrané skladby z ozvučení — podle programu dne.';
  }
  if (liveDj) return 'O hudební doprovod se postará živý DJ.';
  return null;
}

export function isLikelySpotifyPlaylistUrl(url: string): boolean {
  const u = url.trim().toLowerCase();
  return u.startsWith('https://open.spotify.com/') || u.startsWith('http://open.spotify.com/');
}
